// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    connectorId: z.string().min(1).max(128),
    assertionIdHash: z.string().min(1).max(64),
    createdAt: z.number().optional(),
    expiresAt: z.number(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    connectorId: z.string().min(1).max(128),
    assertionIdHash: z.string().min(1).max(64),
    createdAt: z.number(),
    expiresAt: z.number(),
});
export const IdpInitiatedSamlSsoAssertions = Object.freeze({
    table: 'idp_initiated_saml_sso_assertions',
    tableSingular: 'idp_initiated_saml_sso_assertion',
    fields: {
        tenantId: 'tenant_id',
        connectorId: 'connector_id',
        assertionIdHash: 'assertion_id_hash',
        createdAt: 'created_at',
        expiresAt: 'expires_at',
    },
    fieldKeys: [
        'tenantId',
        'connectorId',
        'assertionIdHash',
        'createdAt',
        'expiresAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
